

















import { Component, Vue, Prop } from 'vue-property-decorator';
import { getIssueAttachment } from '@/services/api.service';
import { IAttachment } from '@/lib/interfaces';

@Component
export default class AttachmentRow extends Vue {
  @Prop() private attachment!: IAttachment;

  private async onClickAttachment() {
    getIssueAttachment(this.$route.query.issue_id as string, this.attachment._id);
  }

  private get attachmentType(): string {
    if (/.+\.(png|jpe?g|gif)$/.test(this.attachment.title)) {
      return 'image-icon';
    }
    return 'file-icon';
  }
}
